export default __webpack_public_path__ + "static/media/Step2-2.6a00c004.png";